module.exports = __webpack_public_path__ + "img/135.7.1ffeaca8.png";